const schema = {
  'Tên học sinh': {
    prop: 'studentName',
    type: String,
  },
  'Mã học sinh': {
    prop: 'code',
    type: String,
  },
  Lớp: {
    prop: 'studentClass',
    type: String,
  },
  'Ngày sinh': {
    prop: 'dob',
    type: String,
  },
  'Giới tính': {
    prop: 'gender',
    type: String,
  },
  'Dân tộc': {
    prop: 'ethnic',
    type: String,
  },
  'Địa chỉ hiện tại': {
    prop: 'address',
    type: String,
  },
  'Tỉnh/thành phố': {
    prop: 'province',
    type: String,
  },
  'Quận/huyện': {
    prop: 'district',
    type: String,
  },
  SĐT: {
    prop: 'phone',
    type: String,
  },
  Email: {
    prop: 'email',
    type: String,
  },
  'Họ và tên Bố': {
    prop: 'dadName',
    type: String,
  },
  'Nghề nghiệp của Bố': {
    prop: 'dadJob',
    type: String,
  },
  'Cơ quan của Bố': {
    prop: 'dadCompany',
    type: String,
  },
  'SĐT Bố': {
    prop: 'dadPhone',
    type: String,
  },
  'Email của Bố': {
    prop: 'dadEmail',
    type: String,
  },
  'Họ và tên Mẹ': {
    prop: 'momName',
    type: String,
  },
  'Nghề nghiệp của Mẹ': {
    prop: 'momJob',
    type: String,
  },
  'Cơ quan của Mẹ': {
    prop: 'momCompany',
    type: String,
  },
  'SĐT Mẹ': {
    prop: 'momPhone',
    type: String,
  },
  'Email của Mẹ': {
    prop: 'momEmail',
    type: String,
  },
  'Ghi chú về Học sinh': {
    prop: 'notes',
    type: String,
  },
}

export { schema }
